import React from "react";
import { T } from "../theme";

// Small form primitives for the admin workspace. Plain, dense, consistent.
export const input = { flex: "1 1 160px", minWidth: 0, padding: "8px 10px", fontSize: 13, border: `1px solid ${T.borderSubtle}`, borderRadius: T.radiusSm, outline: "none", fontFamily: T.fontSans, background: T.canvas, color: T.root, boxSizing: "border-box" };
export const card = { background: T.canvas, borderRadius: T.radiusMd, border: `1px solid ${T.borderSubtle}`, padding: "18px 22px", marginBottom: 18, boxShadow: T.shadowSm };
export const h3 = { fontSize: 14, fontWeight: 700, color: T.root, margin: 0 };
export const hint = { fontSize: 12, color: T.fgMuted, marginTop: 4 };
export const btn = (primary) => ({ padding: "8px 16px", fontSize: 12, fontWeight: 600, border: primary ? "none" : `1px solid ${T.borderSubtle}`, borderRadius: T.radiusSm, cursor: "pointer", fontFamily: T.fontSans, background: primary ? T.root : "transparent", color: primary ? T.fgOnDark : T.root });
export const icon = { width: 22, height: 22, border: "none", background: "transparent", cursor: "pointer", fontSize: 12, color: T.fgSecondary, padding: 0 };

export function Field({ label, children, width }) {
  return (
    <label style={{ display: "flex", flexDirection: "column", gap: 4, flex: width ? `0 0 ${width}` : "1 1 160px", minWidth: 0 }}>
      <span style={{ fontSize: 11, fontWeight: 600, color: T.fgSecondary, textTransform: "uppercase", letterSpacing: "0.05em" }}>{label}</span>
      <span style={{ display: "flex", minWidth: 0 }}>{children}</span>
    </label>
  );
}
export function Row({ children, align = "flex-end" }) {
  return <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: align, marginBottom: 12 }}>{children}</div>;
}
export const Text = ({ value, onChange, ...rest }) => <input value={value ?? ""} onChange={e => onChange(e.target.value)} style={input} {...rest} />;
export const Num = ({ value, onChange, ...rest }) => <input type="number" value={value === undefined || value === null ? "" : value} onChange={e => onChange(e.target.value === "" ? "" : Number(e.target.value))} style={{ ...input, flex: "0 1 130px" }} {...rest} />;
export const Select = ({ value, onChange, options, ...rest }) => (
  <select value={value ?? ""} onChange={e => onChange(e.target.value)} style={{ ...input, flex: "0 1 170px" }} {...rest}>
    {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
  </select>
);

// Reorder / delete controls for a list row.
export function RowControls({ onUp, onDown, onDelete }) {
  return (
    <span style={{ display: "inline-flex", gap: 2, flexShrink: 0 }}>
      <button type="button" onClick={onUp} title="Move up" style={icon}>▲</button>
      <button type="button" onClick={onDown} title="Move down" style={icon}>▼</button>
      <button type="button" onClick={onDelete} title="Remove" style={icon}>✕</button>
    </span>
  );
}
export const move = (list, i, d) => { const j = i + d; if (j < 0 || j >= list.length) return list; const n = [...list]; [n[i], n[j]] = [n[j], n[i]]; return n; };
export const without = (list, i) => list.filter((_, k) => k !== i);
export const patchAt = (list, i, patch) => list.map((x, k) => k === i ? { ...x, ...patch } : x);
